export default __webpack_public_path__ + "static/media/Comp.094c7977.png";